import React, { useEffect, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useModuleNav, ModuleNavItem } from '../../contexts/ModuleNavContext';
import { useBreadcrumb } from '../../contexts/BreadcrumbContext';

const AUDIT_NAV_ITEMS: ModuleNavItem[] = [
  { to: '/audit', labelKey: 'audit.tabs.overview', end: true, group: 'nav.groups.overview' },
  { to: '/audit/application-report', labelKey: 'audit.tabs.sprayReport', group: 'nav.groups.reports' },
];

const AuditLayout: React.FC = () => {
  const { t } = useTranslation();
  const { setModule } = useModuleNav();

  const navItems = useMemo(() => AUDIT_NAV_ITEMS, []);

  useEffect(() => {
    setModule(t('audit.landing.title'), navItems);
    return () => setModule(null, null);
  }, [setModule, t, navItems]);

  useBreadcrumb([
    { label: 'Citrus Synch', to: '/' },
    { label: t('audit.landing.title'), to: '/audit' },
  ]);

  return (
    <div data-testid="audit-layout">
      <Outlet />
    </div>
  );
};

export default AuditLayout;
